export const generateResponsiveStyle = () => {
    return {
      position: "absolute" as const,
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 420,
      bgcolor: "#ffffff",
      boxShadow: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
      p: 4,
      borderRadius: "16px",
      outline: "none",
      border: "1px solid #f1f5f9",
    };
  };
